import { Ontario } from '../../../entity'
import { person } from './person'

export const lessee = person

export type Lessee = Ontario.Lessee
